var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAtf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#002455;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M13.711,23.1a5.226,5.226,0,0,0-.157-.7l-.175-.552H11.53l-.175.552a3.662,3.662,0,0,0-.163.7H9.673a6.192,6.192,0,0,0,.312-.791l1.4-3.907a4.011,4.011,0,0,0,.208-.7h1.694a5.072,5.072,0,0,0,.221.7l1.408,3.907c.122.344.226.61.312.791Zm-1.267-4.29-.6,1.948h1.219Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.664,22.124a7.364,7.364,0,0,0,.053.98H16.282a7.18,7.18,0,0,0,.053-.98V18.853h-.767a9.02,9.02,0,0,0-.98.045v-1.24a8.664,8.664,0,0,0,.967.045H18.4a8.488,8.488,0,0,0,1.013-.045V18.9a8.283,8.283,0,0,0-1.013-.045h-.734Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M21.25,21.976A6.69,6.69,0,0,0,21.3,23.1h-1.4a6.53,6.53,0,0,0,.06-1.111V18.633a6.486,6.486,0,0,0-.053-.947c.266.012.447.018.948.018h1.876a7.7,7.7,0,0,0,1.09-.045v1.234a8.644,8.644,0,0,0-1.084-.046H21.25v1.065h1.22a8.442,8.442,0,0,0,1.038-.045v1.2a8.379,8.379,0,0,0-1.038-.045H21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.573,7.9h9.442a.75.75,0,0,1,.75.75v2.842a.75.75,0,0,1-.75.75H18.827V12.9h4.1a.75.75,0,0,1,.613.318l2.043,2.9,6.8-2.142a.75.75,0,0,1,.852.3l.633.965a.75.75,0,0,1-.05.89l-8.875,10.7a.75.75,0,0,1-.577.271H7.627a.75.75,0,0,1-.747-.82l.277-2.959L1.528,21.531a.75.75,0,0,1-.492-.925L3.489,12.2a.75.75,0,0,1,.915-.514L8.914,12.9h4.941v-.657H11.573a.75.75,0,0,1-.75-.75V8.649A.75.75,0,0,1,11.573,7.9Zm8.692,1.5H12.323v1.342H14.6a.75.75,0,0,1,.75.75v2.157a.75.75,0,0,1-.75.75H8.815a.75.75,0,0,1-.2-.026l-3.9-1.051-2.042,7,5.507,1.754a.75.75,0,0,1,.519.784L8.45,25.6H24.016l8.3-10-.018-.027L25.512,17.71a.75.75,0,0,1-.838-.283L22.539,14.4H18.077a.75.75,0,0,1-.75-.75V11.491a.75.75,0,0,1,.75-.75h2.188ZM5.924,15.262a.75.75,0,0,1,.186.024l2.608.669a.75.75,0,0,1,.56.8l-.311,3.113A.75.75,0,0,1,8,20.51l-3.016-.941a.75.75,0,0,1-.5-.9L5.2,15.828a.75.75,0,0,1,.727-.566Zm1.8,1.985-1.255-.322-.36,1.423,1.46.455Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtf);
export default __webpack_public_path__ + "static/media/icon_atf.7ffd59f2e695a7c06cca787ece35a770.svg";
export { ForwardRef as ReactComponent };